"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graph_1 = require("./graph");
const deserialize_1 = require("./v1/util/deserialize");
const error_1 = require("./error");
const v2_1 = require("./v2");
function deserialize(obj) {
    if (obj['version'] === graph_1.GraphVersions.V1 || obj['version'] === graph_1.GraphVersions.Latest)
        return (0, deserialize_1.default)(obj);
    if (obj['version'] === graph_1.GraphVersions.V2)
        return v2_1.V2QuantumGraph.deserialize(obj);
    throw new error_1.default('Cannot deserialize quantum graph: Invalid version');
}
exports.default = deserialize;
